import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=4b60e578&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=4b60e578&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/clawmachine_yardi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b60e578"]])

export default __exports__